import { useCalculationsStore } from '@/stores'
import { createPrefetchGuard } from '@/utils/routerGuards'
import Calculations from '@/views/Calculations/Index.vue'

export default [
    {
        path: '/calculations',
        name: 'calculations',
        component: Calculations,
        meta: {
            title: 'calculations.pageTitle',
            menuRendered: true,
            menuTitle: 'calculations.menuTitle',
            icon: 'mdi-currency-usd',
            permission: 'calculations'
        },
        redirect: { name: 'calculationsCalculations' },
        children: [
            {
                path: '/calculations/calculations',
                name: 'calculationsCalculations',
                component: () => import('@/views/Calculations/Calculations/Index.vue'),
                meta: {
                    title: 'calculations.list.pageTitle',
                    requiresAuth: true,
                    permission: 'calculations_read'
                }
            },
            {
                path: '/calculations/calculations/:id',
                name: 'calculationsCalculation',
                component: () => import('@/views/Calculations/Calculation/Index.vue'),
                beforeEnter: createPrefetchGuard({
                    getId: (to) => to.params?.id,
                    fetch: async (id) => {
                        const calculationsStore = useCalculationsStore()
                        await calculationsStore.prefetchCalculationResources()

                        if (String(calculationsStore.calculation?.id) === String(id)) {
                            return
                        }

                        await calculationsStore.fetchCalculation(id)
                    },
                    onMissingId: () => ({ name: 'calculationsCalculations' }),
                    onError: () => ({ name: 'calculationsCalculations' })
                }),
                meta: {
                    title: 'calculations.details.pageTitle',
                    requiresAuth: true,
                    permission: 'calculations_create'
                }
            },
            {
                path: '/calculations/calculations/:id/add-product',
                name: 'calculationsCalculationAddProduct',
                component: () => import('@/views/Calculations/Calculation/components/ClientAndProducts/Index.vue'),
                meta: {
                    title: 'calculations.product.addPageTitle',
                    requiresAuth: true,
                    permission: 'calculations_create'
                }
            },
            {
                path: '/calculations/calculations/:id/product/:productId',
                name: 'calculationsCalculationProduct',
                component: () => import('@/views/Calculations/Calculation/components/ClientAndProducts/Index.vue'),
                meta: {
                    title: 'calculations.product.editPageTitle',
                    requiresAuth: true,
                    permission: 'calculations_create'
                }
            }
        ]
    }
]
